/** Selektor für Swiper noSwiping (nur explizite Controls) */
export const SWIPER_NO_SWIPE_SELECTOR =
  ".rechtsgebiete-kontakt-button, .home-kontakt-button, .rechtsgebiete-tab, .swiper-no-swiping";

/** Touch-Propagation stoppen bei interaktiven Elementen (Tap ≠ Swipe) */
const INTERACTIVE_TOUCH_SELECTOR =
  `${SWIPER_NO_SWIPE_SELECTOR}, a, button, input, textarea, select, label, [role="button"]`;

const isInteractiveTarget = (target) =>
  target?.closest?.(INTERACTIVE_TOUCH_SELECTOR);

/**
 * Klicks/Taps dürfen nie einen Slide-Wechsel auslösen – nur bewusste Wischgesten.
 * Bubble-Phase: Ziel-Handler (Tabs, Links) laufen zuerst, danach kein Swiper.
 * @param {HTMLElement} container .fullscreen-swiper
 */
export function initSwiperInteractiveElements(container) {
  container.addEventListener("click", (e) => {
    if (e.target.closest(".slide-content")) {
      e.stopPropagation();
    }
  });

  container.addEventListener(
    "touchstart",
    (e) => {
      if (isInteractiveTarget(e.target)) {
        e.stopPropagation();
      }
    },
    { capture: true, passive: true },
  );

  container.addEventListener(
    "touchmove",
    (e) => {
      if (isInteractiveTarget(e.target)) {
        e.stopPropagation();
      }
    },
    { capture: true, passive: true },
  );

  container.addEventListener(
    "touchend",
    (e) => {
      if (isInteractiveTarget(e.target)) {
        e.stopPropagation();
      }
    },
    { capture: true },
  );
}
